export function formatDateLong(d) {
  return d.toLocaleDateString(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
export function formatTime(d) {
  return d.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
  });
}
export function addMonths(date, n = 1) {
  const d = new Date(date);
  d.setMonth(d.getMonth() + n);
  return d;
}
